export enum CoverType {
  Hospital = 'Hospital',
  Extras = 'Extras',
  HospitalAndExtras = 'Hospital & Extras',
}

export enum CoverIsFor {
  Single = 'Single',
  Couple = 'Couple',
  Family = 'Family',
  SingleParentFamily = 'Single Parent Family',
}

export type Institution = {
  institution_code: string;
  institution_name: string;
};
